<template>
  <router-link class="flex items-center" tag="span" :to="{name: 'chat'}">
    <feather-icon icon="MessageCircleIcon" :badge="unseenMsg" class="cursor-pointer mr-4 transform scale-100"></feather-icon>
  </router-link>
</template>

<script>
    export default {
        name: 'ChatNotifications',
        computed: {
            unseenMsg() {
                return Object.values(this.$store.getters['chat/chats']).reduce((totalUnseenMsgs , chat) => {
                    if(chat.msg.some(msg => !msg.isSeen && !msg.isSent)) return totalUnseenMsgs + 1
                    else return totalUnseenMsgs
                }, 0)
            },
        },
        methods: {
            registerListener() {
                let channel = window.Echo.channel('messages.'+this.$store.getters['auth/user'].id);
                let seenChannel = window.Echo.channel('messages.seen.'+this.$store.getters['auth/user'].id);

                channel.listen('.messages', ({message}) => {
                    const activeChat = this.$store.state.chat.activeChatUser === message.sender_id
                    let payload = {
                        id: message.sender_id,
                        msg: { textContent: message.message, time: message.created_at, isSent: false, isSeen: false}
                    }
                    if(activeChat) payload.msg.isSeen = true
                    this.$store.dispatch('chat/receiveNewMessage', payload)
                    if(activeChat) this.$store.dispatch('chat/markSeenAllMessages', message.sender_id)
                })

                seenChannel.listen('.seen', ({readerId, readAt}) => {
                    const data = this.$store.getters['chat/chatDataOfUser'](readerId)
                    this.$store.commit('chat/MARK_SEEN_ALL_MESSAGES', {
                        id: readerId,
                        readAt: readAt,
                        isSent: true,
                        chatData: data
                    })
                })
            },
            unregisterListener() {
                window.Echo.leave('messages.'+this.$store.getters['auth/user'].id)
                window.Echo.leave('messages.seen.'+this.$store.getters['auth/user'].id)
            },
        },
        created() {
            this.registerListener()
            this.$store.dispatch('chat/fetchChatContacts')
        },
        beforeDestroy() { this.unregisterListener() },
    }
</script>
